import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Button from "../Button"
import ButtonGroup from "../ButtonGroup"
import Section from "../Section"
import Image from "../Image"
import Content from "../Content"
import { linkResolver } from "utils/linkResolver"
import { valuable } from "utils/worthy"

const StyledCTASection = styled(Section)`
  z-index: 15;
  padding-top: 4rem;
  padding-bottom: 4rem;

  ${(props) => props.theme.media.tablet_landscape_up`
    padding-top: 8rem;
    padding-bottom: 8rem;
  `}
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;

  ${(props) => props.theme.media.tablet_landscape_up`
    text-align: left;
    flex-direction: row;
    justify-content: center;
  `}
`

const StyledImgWrapper = styled.div`
  width: 12.8rem;
  height: 12.8rem;
  display: block;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 1 12.8rem;

  img {
    width: 100%;
    height: 100%;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    width: 25.6rem;
    height: 25.6rem;
    flex: 0 1 25.6rem;
  `}
`

const StyledContentInner = styled.div`
  h2 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  flex: 0 1 auto;
  max-width: 60rem;
  ${(props) => props.theme.media.tablet_landscape_up`
    flex: 0 1 60rem;
    margin-left: 4rem;
  `}
`

function CTASection({ children, img, content, buttons, ...props }) {
  function renderButtons() {
    return buttons.map((button, i) => {
      const { link, display_text, primary } = button
      return (
        <Button
          key={`cta_b_${i}`}
          forwardedAs="a"
          invert={primary}
          href={valuable(link) ? link.url || linkResolver(link._meta) : ""}
          variant={primary ? "secondary" : "default"}
        >
          {display_text}
        </Button>
      )
    })
  }

  return (
    <StyledCTASection bg="white">
      <StyledContent>
        <StyledImgWrapper>
          <Image
            fluid={
              content.team_member?.imageSharp.childImageSharp.desktop || null
            }
            alt={content.team_member?.image.alt}
          />
        </StyledImgWrapper>
        <StyledContentInner>
          <Content content={content.cta_title} />
          <Content content={content.cta_content} />
          <ButtonGroup>{renderButtons()}</ButtonGroup>
        </StyledContentInner>
      </StyledContent>
    </StyledCTASection>
  )
}

export default CTASection

CTASection.defaultProps = {}
CTASection.propTypes = {
  children: PropTypes.node,
}
